import type { VideoIntegrationType } from "@tellescope/types-models";

export const VALID_VIDEO_INTEGRATIONS = ["Zoom", "Twilio", "No Integration"] as const;

/**
 * Narrows an arbitrary/optional string to a valid {@link VideoIntegrationType}, or `undefined` when it
 * isn't one. Unlike the template editor's converter, this does not default to `"No Integration"` — an
 * event with no integration should leave the field unset rather than persist a placeholder value.
 */
export const toVideoIntegrationOrUndefined = (str: string | undefined): VideoIntegrationType | undefined =>
  VALID_VIDEO_INTEGRATIONS.find((item) => item === str);
